import React, { useEffect, useState } from "react"
import { LocalPersistence } from '../../../../../../factories';
import { Form, Row, Col, Select, Modal, message } from 'antd';
import Input from '../../../../../ui/Input';
import TextArea from '../../../../../ui/TextArea';
import ActionButtonsBar from '../../../../../ui/ActionButtonsBar'
import { updateMeetingRoom, deleteMeetingRoom } from '../../../../../../services/meetingrooms'
import { getOTACodes } from '../../../../../../services/common'
import styles from '../../../index.module.css'
import Loading from "../../../../../Loading";
const { Option } = Select;
const RoomDetailEdit = (props: any) => {
    const [form] = Form.useForm()
    const [uomData, setUomData] = useState<any>([])
    const [editLoading, setEditLoading] = useState(false)
    const [disabledStatus, setDisabledStatus] = useState<boolean>(false)
    useEffect(() => {
        getUomData()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
    const getUomData = async () => {
        let res = await getOTACodes('UOM', 'Area')
        if (res && res.otacodes && res.otacodes.length != 0) {
            setUomData(res.otacodes)
        } else {
            setUomData([])
        }
    };
    const SaveClick = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()

        form.validateFields().then(async (value) => {
            setEditLoading(true)
            let bodyQuery = {
                "supplier": session.supplier,
                "propertyId": session.propertyId,
                "property": {
                    "meetingrooms": {
                        "meetingroomsid": props.meetingroomsId,
                        "meetingroom": [
                            {
                                "roomid": props.currentLine.roomid || '',
                                "roomlangid": props.currentLine.roomlangid,
                                "id": value.id,
                                "name": value.name || '',
                                "area": value.area || '',
                                "length": value.length || '',
                                "height": value.height || '',
                                "width": value.width || '',
                                "uom": value.uom || '',
                                "rank": value.rank || '',
                                "decor": value.decor || '',
                                "mincharge": value.mincharge || '',
                                "tenbytenexhibit": value['tenbytenexhibit'] || '',
                                "onesquarecapacity": value.onesquarecapacity || '',
                                "othercapacity": value.othercapacity || '',
                                "largestcapacity": value.largestcapacity || '',
                                "description": value.description || ''
                            }
                        ]
                    }
                }
            }


            updateMeetingRoom(bodyQuery).then(res => {
                if (res.result.success) {
                    props.setCurrentLine({
                        ...props.currentLine,
                        ...{
                            "id": value.id || '',
                            "name": value.name || '',
                            "area": value.area || '',
                            "length": value.length || '',
                            "height": value.height || '',
                            "width": value.width || '',
                            "uom": value.uom || '',
                            "rank": value.rank || '',
                            "decor": value.decor || '',
                            "mincharge": value.mincharge || '',
                            "tenbytenexhibit": value['tenbytenexhibit'] || '',
                            "onesquarecapacity": value.onesquarecapacity || '',
                            "othercapacity": value.othercapacity || '',
                            "largestcapacity": value.largestcapacity || '',
                            "description": value.description || ''
                        }
                    })
                    props.setRoomDetailEditFlag(false)
                    window.cancelEdition()
                    props.setTableOneNavDisabled(false)
                } else {
                    message.error({
                        content: res?.error[0]?.message || 'operation failed'
                    });
                }
                setEditLoading(false)
            }, err => {
                message.error({
                    content: err?.message || err?.error[0]?.message
                });
                setEditLoading(false)
            })
        }).catch(() => {
            setEditLoading(false)
            message.error({
                content: 'Check all the fields please.',
            });
        })
    }
    const ModalHead = () => {
        return (
            <div className={styles.modalHead}>Confirm</div>
        )
    }
    const DeleteClick = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content: `Are you sure you want to delete ${props.currentLine.name} ?`,
            cancelText: 'Cancel',
            okText: 'Delete',
            onOk: async () => {
                const bodyQuery = {
                    supplier: session.supplier,
                    propertyId: session.propertyId,
                    property: {
                        meetingrooms: {
                            meetingroomsid: props.meetingroomsId,
                            meetingroom: [
                                {
                                    roomid: props.currentLine.roomid,
                                    roomlangid: props.currentLine.roomlangid
                                }
                            ]
                        }
                    }
                }
                deleteMeetingRoom(bodyQuery).then(res => {
                    if (res.result.success) {
                        props.setCurrentOneNav('orign')
                        props.setRoomDetailEditFlag(false)
                        window.cancelEdition()
                        props.setTableOneNavDisabled(false)
                    } else {
                        message.error({
                            content: res?.error[0]?.message || 'operation failed'
                        });
                    }
                }, err => {
                    message.error({
                        content: err?.message || err?.error[0]?.message
                    });
                })

            },
            onCancel() {

            },
        });
    }
    const DeleteClickFun = async () => {
        await DeleteClick()
        props.setMeetingroomTabsActivityKey('2')
    }
    useEffect(() => {
        props.currentLine ?
            form.setFieldsValue(props.currentLine) :
            form.resetFields()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])
    const validateFieldsError = () => {
        form.validateFields().then(() => {
            setDisabledStatus(false)

        }).catch(() => {
            let savelock = false
            let s = form?.getFieldsError()
            for (let i = 0; i < s.length; i++) {
                if (s[i].errors.length) {
                    savelock = true;
                    break
                }
            }
            setDisabledStatus(savelock)
        })
    }

    if (editLoading) return <Loading type='large' />
    return (
      <div className={styles.outCon}>
        <div className={styles.inCon}>
          <div className={styles.tableName}>{props.currentLine.name}</div>
        </div>
        <Form
          layout='vertical'
          form={form}
          name='basic'
          initialValues={{ remember: true }}
          onValuesChange={validateFieldsError}>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Room Id'
                name='id'
                rules={[
                  {
                    max: 32,
                    message: 'You have reached the max character length of 32',
                  },
                ]}>
                <Input maxLength={32} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Room Name'
                name='name'
                rules={[
                  { required: true, message: 'This field is required' },
                  {
                    max: 128,
                    message: 'You have reached the max character length of 128',
                  },
                ]}>
                <Input maxLength={128} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                extra={
                  <span className={styles.tipColor}>
                    Please input Total Area in Square feet
                  </span>
                }
                label='Total Space'
                name='area'
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Length'
                name='length'
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Width'
                name='width'
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Height'
                name='height'
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item label='Unit of Measure' name='uom'>
                <Select allowClear showSearch>
                  {uomData.map((item: any, index: any) => {
                    return (
                      <Option key={index} value={item.codeName}>
                        {item.codeName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                extra={
                  <span className={styles.tipColor}>
                    Please input Rank as 1, 2, 3, etcâ€¦ for each Meeting Room
                  </span>
                }
                label='Rank'
                name='rank'
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
            <Form.Item 
              label='Room Decor' 
              name='decor'
              rules={[
                {
                  max: 40,
                  message: 'You have reached the max character length of 40',
                }]}     
              >
                 <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Minimum Charge'
                name='mincharge'
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Number of 10x10 Exhibits'
                name='tenbytenexhibit'
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Open Square Capacity'
                name='onesquarecapacity'
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Other Capacity'
                name='othercapacity'
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Largest Capacity'
                name='largestcapacity'
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={18}>
              <Form.Item
                label='Description'
                name='description'
                extra={
                  <span className={styles.tipColor}>
                    Lanyon allows 300 characters
                  </span>
                }
                rules={[
                  {
                    max: 300,
                    message: 'You have reached the max character length of 300',
                  },
                ]}>
                <TextArea maxLength={300} maxRows={3} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <ActionButtonsBar
          onDelete={DeleteClickFun}
          onCancel={() => {
            props.setRoomDetailEditFlag(false)
            window.cancelEdition()
            props.setTableOneNavDisabled(false)
          }}
          onSave={SaveClick}
          disabledSave={disabledStatus}
          warningMsg={true}
        />
      </div>
    )
}

export default RoomDetailEdit
